(function () {
    var $body = $('body');
    var reponsiveMenu = {
        vPort: 'screen-sm',
        elementvPort: null,
        isMobile: false, // variable use to determine if responsive mode is on or off
        $menuContainer: $('.responsive-menu-container'),
        leftSectionWidth: null,
        rightSectionWidth: null,
        maxMenuItemWidth: 135,
        $moreDropsown: $('.responsive-menu-nav .menubar > .dropdown-more'),
        $menu: $('.responsive-menu-nav >.drawer__nav'),
        $menuWrapper: $('.responsive-menu-nav'),

        init: function () {
            reponsiveMenu.elementvPort = reponsiveMenu.vPort;
            reponsiveMenu.vPort = [];
            $('.responsive-menu-container').each(function (index) {
                reponsiveMenu.check.viewPort(index, $(this));
                reponsiveMenu.responsive(index);
            });
            reponsiveMenu.control();
            reponsiveMenu.on.build();
        },

        responsive: function (index) {
            $(document).on(reponsiveMenu.vPort[index] + '-on', function () {
                reponsiveMenu.isMobile = true;

                $('.responsive-menu-container').each(function () {
                    if ($(this).data('ctrl-res') === reponsiveMenu.vPort[index]) {
                        $(this).addClass('js--disabled-responsive-menu'); // class will be used in our scss (to replace media queries)
                    }
                });
            });

            $(document).on(reponsiveMenu.vPort[index] + '-off', function () {
                reponsiveMenu.isMobile = false;

                $('.responsive-menu-container').each(function () {
                    if ($(this).data('ctrl-res') === reponsiveMenu.vPort[index]) {
                        $(this).removeClass('js--disabled-responsive-menu'); // class will be used in our scss (to replace media queries)
                    }
                });
            });
        },

        control: function () {
            $(window).on('resize', function () {
                reponsiveMenu.modifyMenu();
            });

            $body.on('touchend', '.dropdown-more >a, .dropdown.menu-parent>a ', function (e) {
                if ($(this).parents('.dropdown-more').length > 0 && !$(this).parent().hasClass('.dropdown-more')) {
                    $('.responsive-menu-nav .js--opened:not(.dropdown-more)')
                        .not($(this).parent())
                        .removeClass('js--opened');
                } else {
                    $('.responsive-menu-nav .js--opened').not($(this).parent()).removeClass('js--opened');
                }

                $(this).parent().toggleClass('js--opened');
                if (!$(this).parent().hasClass('js--opened')) {
                    $(this).parent().addClass('js--forceClose');
                } else {
                    $(this).parent().removeClass('js--forceClose');
                }
            });

            $body.click(function (e) {
                $('.responsive-menu-nav .js--opened:not(:hover)').removeClass('js--opened');
            });
        },
        on: {
            build: function () {
                reponsiveMenu.$menuWrapper.show();
                reponsiveMenu.modifyMenu();

                setTimeout(function () {
                    reponsiveMenu.modifyMenu();
                }, 800);
            },
        },
        modifyMenu: function () {
            $('.responsive-menu-container').each(function () {
                reponsiveMenu.$menuContainer = $(this);
                reponsiveMenu.$moreDropsown = reponsiveMenu.$menuContainer.find('.dropdown-more');

                if (!reponsiveMenu.$menuContainer.hasClass('js--disabled-responsive-menu')) {
                    reponsiveMenu.leftSectionWidth = reponsiveMenu.$menuContainer.find('.left-section').width();
                    reponsiveMenu.rightSectionWidth = reponsiveMenu.$menuContainer.find('.right-section').width();
                    reponsiveMenu.$menu = reponsiveMenu.$menuContainer.find('.drawer__nav');
                    reponsiveMenu.$menuWrapper = reponsiveMenu.$menuContainer.find('.responsive-menu-nav');

                    const availableMenuWidth =
                        reponsiveMenu.$menuContainer.width() -
                        (reponsiveMenu.leftSectionWidth + reponsiveMenu.rightSectionWidth + 35);
                    let menuWidth = reponsiveMenu.$menu.width();

                    if (availableMenuWidth > 0 && menuWidth > 0) {
                        if (menuWidth > availableMenuWidth) {
                            while (menuWidth > availableMenuWidth) {
                                // Try class-based selector first, fallback to role-based for compatibility
                                let $lastMenuItem = reponsiveMenu.$menu
                                    .find('.menubar > .menu-item:not(.dropdown-more)')
                                    .last();
                                if ($lastMenuItem.length === 0) {
                                    $lastMenuItem = reponsiveMenu.$menu
                                        .find('.menubar > [role="menuitem"]:not(.dropdown-more)')
                                        .last();
                                }
                                if ($lastMenuItem.length > 0) {
                                    reponsiveMenu.$moreDropsown.removeClass('hidden');
                                    reponsiveMenu.$moreDropsown
                                        .find('>.dropdown__menu')
                                        .prepend($lastMenuItem[0].outerHTML);
                                    $lastMenuItem.remove();
                                    menuWidth = reponsiveMenu.$menu.width();
                                } else {
                                    break;
                                }
                            }
                        } else if (
                            availableMenuWidth > menuWidth + reponsiveMenu.maxMenuItemWidth &&
                            !reponsiveMenu.$moreDropsown.hasClass('hidden')
                        ) {
                            while (availableMenuWidth > menuWidth) {
                                // Try class-based selector first, fallback to role-based for compatibility
                                let $moreItems = reponsiveMenu.$moreDropsown.find('.dropdown__menu .menu-item');
                                if ($moreItems.length === 0) {
                                    $moreItems = reponsiveMenu.$moreDropsown.find('.dropdown__menu [role="menuitem"]');
                                }
                                const $firstMoreItem = $moreItems.first();
                                if ($firstMoreItem.length > 0) {
                                    reponsiveMenu.$moreDropsown.before($firstMoreItem[0].outerHTML);

                                    if ($moreItems.length <= 1) {
                                        reponsiveMenu.$moreDropsown.addClass('hidden');
                                    }

                                    $firstMoreItem.remove();
                                    menuWidth = reponsiveMenu.$menu.width();
                                } else {
                                    break;
                                }
                            }

                            if (menuWidth > availableMenuWidth) {
                                reponsiveMenu.modifyMenu();
                            }
                        }
                    }
                } else {
                    if (!reponsiveMenu.$moreDropsown.hasClass('hidden')) {
                        reponsiveMenu.$moreDropsown.addClass('hidden');
                        reponsiveMenu.$moreDropsown.before(reponsiveMenu.$moreDropsown.find('.dropdown__menu').html());
                        reponsiveMenu.$moreDropsown.find('.dropdown__menu').empty();
                    }
                }
            });
        },
        check: {
            viewPort: function (index, $el) {
                if (typeof $el.data('ctrl-res') != 'undefined' || $el.data('ctrl-res') === '') {
                    reponsiveMenu.vPort[index] = $el.data('ctrl-res');
                } else {
                    $el.data('ctrl-res', reponsiveMenu.elementvPort);
                    reponsiveMenu.vPort[index] = reponsiveMenu.elementvPort;
                }
            },
        },
    };

    UX.reponsiveMenu = reponsiveMenu; // add to global namespace
})();
